import * as React from 'react';
import classnames from 'classnames';
import InlineIcon from '../../general/inline_icon/inline_icon';

const styles = require('./form_error.module.scss');
const xIcon = require('iconic/x-transparent.svg');

interface Props {
  text: string | JSX.Element;
}

const FormError = (props: Props) => {
  const text = Array.isArray(props.text) ? props.text.join(' ') : props.text;
  const hasHtml = typeof text === 'string' && text.includes('<') && text.includes('>');

  return (
    <div className={classnames(styles.error, 'lj-error')}>
      <InlineIcon className={styles.icon} alt='x' path={xIcon} />
      {hasHtml ? (
        <span dangerouslySetInnerHTML={{ __html: text }} />
      ) : (
        <span>{text}</span>
      )}
    </div>
  );
};

export default FormError;
